import React, { useMemo } from "react";
import { Box, Button, Card, Chip, Grid, LinearProgress, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import RiskPanelHeader from "./RiskPanelHeader";
import { overviewChartPalette } from "styles/theme";

const RiskTrend = ({ data }) => {

    const categories = data?.data?.trend?.map(
        item => `${item?.monthName} ${item?.year}`
    );

    const seriesData = data?.data?.trend?.map(
        item => item?.averageRiskRating
    );

    const options = {
        chart: {
            type: "column",
            height: 360,
            spacingTop: 30,
            spacingBottom: 20,
        },

        title: {
            text: null,
        },

        xAxis: {
            categories: categories,
            lineColor: "#E5E7EB",
            tickColor: "#E5E7EB",
            labels: {
                style: {
                    color: "#6B7280",
                    fontSize: "12px",
                },
            },
        },

        yAxis: {
            min: 0,
            max: 20,
            // tickInterval: 50,
            title: {
                text: null,
            },
            gridLineColor: "#F1F5F9",
            labels: {
                style: {
                    color: "#6B7280",
                    fontSize: "12px",
                },
            },
        },

        tooltip: {
            enabled: true,
        },

        plotOptions: {
            column: {
                borderRadius: 6,
                pointWidth: 48,
                dataLabels: {
                    enabled: true,
                    format: "{y}",
                    style: {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#374151",
                    },
                },
            },
        },

        series: [
            {
                name: "Risk",
                data: seriesData,
                color: overviewChartPalette.indigo,
                showInLegend: false,
            },
        ],

        credits: {
            enabled: false,
        },
    };

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #E4E4E4",
                width: '100%',
                height: { xs: "auto", md: 450 },
                boxSizing: "border-box",
            }}
        >
            <RiskPanelHeader eyebrow="Exposure trend" title="Risk Movement" subtitle="Track whether total project exposure is improving or deteriorating over time." />
            <Box sx={{
                width: '100%',
                borderBottom: "1px solid #E4E4E4",
                p: 1.5,
                display: 'none',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0
                    }}>
                        Risk Performance Trend
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: '16px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        Shows how overall project risk performance increasing or decreasing over time.
                    </Typography>
                </Box>
            </Box>
            <Grid container>
                <Grid size={{ md: 12 }}>
                    <HighchartsReact highcharts={Highcharts} options={options} />

                </Grid>
            </Grid>
        </Card>
    );
};

export default RiskTrend;
